window.onload = function () {
  const priceSelector = document.querySelectorAll('.price-item');
  if(priceSelector.length>0){
    for(let i = 0; i<priceSelector.length;i++){
      const price = priceSelector[i].innerText.slice(1);
      if(price == 0)
        {
          priceSelector[i].style.display = 'none';
        }
    }
  }
}